export const CAPTCHA = 'Captcha/success';
export const LOADING_CAPTCHA = 'Captcha/loading';
export const LOGIN = 'Login/success';
export const LOADING_LOGIN = 'Login/loading';
export const LOGOUT = 'Logout/success';
export const LOADING_LOGOUT = 'Logout/loading';
export const VALIDATE_TOKEN = 'ValidateToken/success';
export const LOADING_VALIDATE_TOKEN = 'ValidateToken/loading';
export const REFRESH_TOKEN = 'RefreshToken/success';
export const LOADING_REFRESH_TOKEN = 'RefreshToken/loading';
export const VALIDATE_TOKEN_BSS = 'ValidateTokenBSS/success';
export const LOADING_VALIDATE_TOKEN_BSS = 'ValidateTokenBSS/loading';
export const VALIDATE_TOKEN_BRISPOT = 'ValidateTokenBRISPOT/success';
export const LOADING_VALIDATE_TOKEN_BRISPOT = 'ValidateTokenBRISPOT/loading';
export const TERM_AND_CONDITION = 'TermAndCondition/success';
export const LOADING_TERM_AND_CONDITION = 'TermAndCondition/loading';
export const MENU_LIST = 'MenuList/success';
export const LOADING_MENU_LIST = 'MenuList/loading';
export const LIST_WORD_STYLING = "ListWordStyling/success";
export const LOADING_LIST_WORD_STYLING = "ListWordStyling/loading";
export const HEADLINE = "Headline/success";
export const LOADING_HEADLINE = "Headline/loading";
export const LIST_LAYANAN = "ListLayanan/success";
export const LOADING_LIST_LAYANAN = "ListLayanan/loading";
export const LIST_PRODUK = "ListProduk/success";
export const LOADING_LIST_PRODUK = "ListProduk/loading";
export const CALL_TO_ACTION = "CallToAction/success";
export const LOADING_CALL_TO_ACTION = "CallToAction/loading";
